/**
 * 土石流向图解析
 */
import { unique, formatText } from "../js/common.js"
function ParaseLiuxiangTu(tables) {
    var headerData = {}
    var valueStartIndex = ""
    var headerText = []

    for (let i = 1; i <= 2; i++) {
        let cells = tables.Rows.Item(i).Cells
        for (let j = 1; j <= cells.Count; j++) {
            var text = cells.Item(j).Value()
            if (text === '挖方' && !valueStartIndex) {
                valueStartIndex = j
            }
            if (text) {
                headerData[i + "_" + j] = text
            } else {
                if (i == 1 && headerData[i + "_" + (j - 1)]) {
                    headerData[i + "_" + j] = headerData[i + "_" + (j - 1)]
                } else {
                    headerData[i + "_" + j] = headerData[(i - 1) + "_" + j]
                }
            }

            if (headerText.indexOf(text) == -1 && (!valueStartIndex || j < valueStartIndex)) {
                if (!text) {
                    text = ""
                }
                headerText.push(text)
            }
        }
    }

    headerText = unique(headerText)

    console.log(headerData, valueStartIndex, headerText)


    var tableData = []

    var totalStartIndex = 0

    let leavel = headerText.length - 1;

    for (let i = 3; i <= tables.Rows.Count; i++) {
        let cells = tables.Rows.Item(i).Cells
        let tableItem = {}
        for (let j = 1; j <= cells.Count; j++) {
            if (cells.Item(j).Height == 0) {
                continue
            }
            var cellText = formatText(cells.Item(j).Value());
            if (cellText === '合计' && totalStartIndex == 0) {
                totalStartIndex = i
            }

            var title = headerData[1 + "_" + j]
            var subTitle = headerData[2 + "_" + j]
            var finishTitle = title + "_" + subTitle
            if (subTitle === title) {
                finishTitle = title
            }
            var needFitValue = false
            if (subTitle == "来源" || subTitle == "去向") {
                if (title === '弃方' || title === '借方') {
                    finishTitle = title + "_" + subTitle
                    needFitValue = true
                } else {
                    finishTitle = headerData[2 + "_" + (j - 1)] + "_" + title + "_" + subTitle
                }
            }
            //处理挖方前 + 借方和弃方的说明
            if ((j < valueStartIndex && !cellText) || (needFitValue && !cellText)) {
                if (!needFitValue) {
                    if (j > 2) {
                        let lastCellText = formatText(cells.Item(j - 1).Value())
                        if (lastCellText) {
                            cellText = lastCellText;
                        } else if (tableData.length > 0) {
                            let lastCellText = tableData[tableData.length - 1][finishTitle]
                            if (lastCellText || lastCellText != cellText) {
                                cellText = lastCellText;
                            }
                        }
                    } else {
                        if (tableData.length > 0) {
                            let lastCellText = tableData[tableData.length - 1][finishTitle]
                            if (lastCellText) {
                                cellText = lastCellText;
                            }
                        }
                    }
                } else {
                    if (tableData.length > 0) {
                        let lastCellText = tableData[tableData.length - 1][finishTitle]
                        if (lastCellText) {
                            cellText = lastCellText;
                        }
                    }
                }
            }
            if (cellText) {
                if (tableItem[finishTitle]) {
                    if (tableItem[finishTitle] != cellText) {
                        tableItem[finishTitle + "_sub"] = cellText
                    }
                } else {
                    tableItem[finishTitle] = cellText
                }

            }
        }
        tableData.push(tableItem)
    }

    console.log(totalStartIndex)
    console.log('层级' + leavel)
    console.log(JSON.parse(JSON.stringify(tableData)))


    //跑不同工程的节点和数值数据
    var totalList = tableData.slice(0, totalStartIndex - 3)
    console.log('totalList', JSON.parse(JSON.stringify(totalList)))

    let nodeData = []
    let qiToList = []
    let jieFromList = []
    //筛选所有得节点所需信息
    totalList.forEach(element => {
        var itemList = []
        Object.keys(element).forEach(key => {
            var newItem = {}
            if (element[key] && element[key] != 0) {
                var type = key.split("_")[1];
                var fang = key.split("_")[0]
                if (type && type != '小计' && ["挖方", "填方", "弃方", "借方"].includes(fang)) {
                    newItem.fang = fang
                    newItem.type = type
                    newItem.value = element[key]
                    if (type == "去向" || type == '来源' && element[key]) {
                        if (fang == '借方') {
                            var findItem = jieFromList.find((item) => item.key === key && item.value === element[key])
                            if (!findItem) {
                                jieFromList.push({ key: key, value: element[key], count: 1 })
                            } else {
                                findItem.count += 1
                            }
                        }
                        if (fang == '弃方') {
                            var findItem = qiToList.find((item) => item.key === key && item.value === element[key])
                            if (!findItem) {
                                qiToList.push({ key: key, value: element[key], count: 1 })
                            } else {
                                findItem.count += 1
                            }
                        }
                    }
                    itemList.push(newItem)
                }
            }
        })
        console.log(itemList)
        var topTitle = element[headerText[1]]
        var title = element[headerText[2]]
        let subTitle = element[headerText[2] + "_sub"]
        if (title != '小计' && subTitle != '小计') {
            let no = element[headerText[0]]
            console.log(title, subTitle, topTitle)
            let key = title
            let topKey = topTitle
            let subInfo = ""
            if (subTitle) {
                subInfo = { no: no, key: subTitle, itemList: itemList, typeList: unique(itemList.filter((item) => !["来源", "去向"].includes(item.type)).map((item) => item.type)) }
            }
            if (subInfo) {
                let findIndex = nodeData.findIndex((item) => item.key === title && item.topKey === topKey)
                console.log(findIndex, nodeData)
                if (findIndex == -1) {
                    nodeData.push({
                        no: no,
                        key: key,
                        topKey: topKey,
                        typeList: [subInfo],
                        count: subInfo.typeList.length
                    })
                } else {
                    nodeData[findIndex].typeList.push(subInfo)
                    nodeData[findIndex].count += subInfo.typeList.length
                }
            } else {
                if (no && key) {
                    nodeData.push({
                        no: no,
                        key: key,
                        topKey: topKey,
                        itemList: itemList,
                        typeList: unique(itemList.filter((item) => !["来源", "去向"].includes(item.type)).map((item) => item.type)),
                        count: unique(itemList.filter((item) => !["来源", "去向"].includes(item.type)).map((item) => item.type)).length
                    })
                }
            }
        }
    });

    console.log('nodeData', nodeData, jieFromList, qiToList)



    // //再跑流向的数据  绘制线路出来
    var liuxiangMapList = []
    var liuxiangList = tableData.slice(0, totalStartIndex - 3)
    console.log(liuxiangList)
    liuxiangList.forEach((item) => {
        var keyList = Object.keys(item).filter((item1) => item1.split("_").length >= 2 && item1.split("_")[1] != "小计" && (item1.split("_")[2] === "去向" || item1.split("_")[2] === "来源"))
        if (keyList.length > 0) {
            console.log(keyList)
            keyList.forEach((key) => {
                let text = item[key].toString()
                var newNumberStr = []
                console.log(text)
                if (text.includes("、")) {
                    const characters = text.split("、");
                    console.log(characters)
                    characters.forEach(character => {
                        newNumberStr.push(formatText(character))
                    });
                } else {
                    console.log(text)
                    // const characters = Array.from(text);
                    // var newNumberStr = []
                    // characters.forEach(character => {

                    // });
                    newNumberStr.push(formatText(text))
                }
                console.log(newNumberStr)
                if (newNumberStr && newNumberStr.length > 0) {
                    var formType = key.split("_")[1]
                    var topTitle = item[headerText[1]]
                    var nowTitle = item[headerText[0]].toString()
                    var type = key.split("_")[0]
                    var newValue = item[formType + "_" + type]
                    var targetValue = []
                    if (newNumberStr.length == 1) {
                        targetValue.push({
                            form: formType === '调入' ? newNumberStr[0] : nowTitle,
                            to: formType === '调入' ? nowTitle : newNumberStr[0],
                            value: newValue
                        })
                    } else {
                        newNumberStr.forEach(number => {
                            targetValue.push({
                                form: formType === '调入' ? number : nowTitle,
                                to: formType === '调入' ? nowTitle : number,
                                value: ""
                            })
                        })
                    }
                    liuxiangMapList.push({
                        "number": newNumberStr,
                        "formType": formType,
                        "topTitle": topTitle,
                        "title": item[headerText[2]],
                        "subTitle": item[headerText[2] + "_sub"] || "",
                        "type": type,
                        "ship": targetValue,
                        "value": newValue,
                    })

                }
            })

        }
    })
    console.log(JSON.parse(JSON.stringify(liuxiangMapList)))

    liuxiangMapList.forEach((item) => {
        if (item.ship.length == 1) {
            findValue(item.ship[0].form, item.ship[0].to, liuxiangMapList, item.formType, item.type, item.ship[0].value)
        }
    })
    console.log(JSON.parse(JSON.stringify(liuxiangMapList)))

    liuxiangMapList.forEach((item) => {
        if (item.ship.length > 1) {
            item.ship.forEach(item1 => {
                if (item1.value) {
                    findValue(item1.form, item1.to, liuxiangMapList, item.formType, item.type, item1.value)
                }
            })
        }
    })
    console.log(JSON.parse(JSON.stringify(liuxiangMapList)))

    var outLsit = []
    var intLsit = []

    liuxiangMapList.forEach(item => {
        if (item.formType === '调出') {
            item.ship.forEach(item1 => {
                var newForm = item1.form
                var newTo = item1.to
                outLsit.push({
                    "topTitle": item.topTitle,
                    "from": newForm,
                    "to": newTo,
                    "value": item1.value,
                    "type": item.type,
                    "title": item.title,
                    "subTitle": item.subTitle
                })
            })
        } else {
            item.ship.forEach(item1 => {
                var newForm = item1.form
                var newTo = item1.to
                intLsit.push({
                    "topTitle": item.topTitle,
                    "from": newForm,
                    "to": newTo,
                    "value": item1.value,
                    "type": item.type,
                    "title": item.title,
                    "subTitle": item.subTitle
                })
            })
        }
    })

    console.log("in", intLsit)
    console.log('out', JSON.parse(JSON.stringify(outLsit)))

    window.Application.PluginStorage.setItem('type', "tushi")
    window.Application.PluginStorage.setItem('headerText', JSON.stringify(headerText))
    window.Application.PluginStorage.setItem('nodeData', JSON.stringify(nodeData))
    window.Application.PluginStorage.setItem('qiToList', JSON.stringify(qiToList))
    window.Application.PluginStorage.setItem('jieFromList', JSON.stringify(jieFromList))
    window.Application.PluginStorage.setItem('tableData', JSON.stringify(tableData))
    window.Application.PluginStorage.setItem('liuxiangList', JSON.stringify(liuxiangList))
    window.Application.PluginStorage.setItem('outLsit', JSON.stringify(outLsit))
}

function findValue(form, to, liuxiangMapList, formType, type, value) {
    if (formType === '调入') {
        formType = '调出'
    } else {
        formType = '调入'
    }
    liuxiangMapList.forEach(liuxiangItem => {
        if (liuxiangItem.formType === formType && liuxiangItem.type === type) {
            for (let index = 0; index < liuxiangItem.ship.length; index++) {
                const item = liuxiangItem.ship[index];
                if (item.form === form && item.to === to && !item.value) {
                    item.value = value
                    if (value === liuxiangItem.value) {
                        liuxiangItem.ship = [item]
                    }
                    console.log('修改值', liuxiangItem)
                    if (liuxiangItem.ship.length > 1 && liuxiangItem.ship.filter((item) => item.value).length == liuxiangItem.ship.length - 1) {
                        var noValueIndex = liuxiangItem.ship.findIndex((item) => !item.value)
                        var sumValue = 0;
                        liuxiangItem.ship.filter((item, index) => {
                            if (item.value) {
                                sumValue += Number(item.value);
                            } else {
                                noValueIndex = index
                            }
                        })
                        liuxiangItem.ship[noValueIndex].value = parseFloat(Number(liuxiangItem.value) - sumValue).toFixed(2)
                    }
                    // if (liuxiangItem.ship.length == 2) {
                    //   if (index == 0) {
                    //     liuxiangItem.ship[1].value = parseFloat(Number(liuxiangItem.value) - Number(value)).toFixed(2)
                    //     findValue(liuxiangItem.ship[1].form, liuxiangItem.ship[1].to, liuxiangMapList, item.type, item.subTitle, liuxiangItem.ship[1].value, item.areaIndex)
                    //   } else {
                    //     liuxiangItem.ship[0].value = parseFloat(Number(liuxiangItem.value) - Number(value)).toFixed(2)
                    //     findValue(liuxiangItem.ship[0].form, liuxiangItem.ship[0].to, liuxiangMapList, item.type, item.subTitle, liuxiangItem.ship[0].value, item.areaIndex)
                    //   }
                    // }
                }
            }
        }
    });
}

export default {
    ParaseLiuxiangTu
}